import { render, staticRenderFns } from "./pipe-lobby-offer.vue?vue&type=template&id=622acd9f&scoped=true"
import script from "./pipe-lobby-offer.vue?vue&type=script&lang=js"
export * from "./pipe-lobby-offer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622acd9f",
  null
  
)

export default component.exports